module.exports = require("core-js/library/fn/symbol/iterator");